import React, { useEffect } from 'react';
import Page from '../../components/page';
import './index.less';

import IMG_ME_A from '../../common/images/aa.png';
import IMG_ME_B from '../../common/images/ab.png';
import IMG_ME_C from '../../common/images/ac.png';

const PageModel = props => {
	return (
		<Page {...{ page: 'adminupkeep', showFooter: true, title: '管理员' }} {...props}>
			<section className="admin-upkeep-container" style={{ minHeight: window.innerHeight - 50 }}>
				<div className='admin-div'>
					{
						[
							{ icon: IMG_ME_A, label: '店铺管理', link: '/admincompanylist' },
							{ icon: IMG_ME_B, label: '设备运行情况', link: '/alltab' },
							{ icon: IMG_ME_C, label: '保养情况', link: '/allupkeeptab' },
						].map((item, index) => {
							return (
								<div key={index} className='admin-div-title' onClick={() => props.history.push(item.link)}>
									<img src={item.icon} alt='' />
									<div className='admin-div-title-text'>{item.label}</div>
								</div>
							)
						})
					}
				</div>
			</section>
		</Page>
	);
};

export default PageModel;
